import React, { useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
} from 'app/components/ui/dialog';
import { Button } from 'app/components/ui/button';

import { CategoriesForm } from '../form';
import { toast } from 'sonner';
import { Form } from 'app/components/ui/form';
import { useForm } from 'react-hook-form';
import { useProductsSlice } from 'app/pages/Product/slice';
import { useCourseSlice } from '../../slice';

interface DialogProductCategoriesProps {
  isOpen: boolean;
  onClose: (isOpen: boolean) => void;
}

interface CategoryFormInputs {
  category_name: string;
  parent_category_id: string;
  slug: string;
  image: string;
}

const DialogAddCategory: React.FC<DialogProductCategoriesProps> = ({
  isOpen,
  onClose,
}) => {
  const { useAddCourseCategoriesMutation } = useCourseSlice();
  const [addCategories, { isLoading, isError, data }] =
    useAddCourseCategoriesMutation();
  const form = useForm();

  function onSubmit(data) {
    let payload = {
      category_name: data.category_name,
      parent_category_id: data.parent_category_id,
      slug: data.slug,
      image: data.image,
    };
    addCategories(payload);
  }

  useEffect(() => {
    console.log(data);
    if (data) {
      toast.success(data?.message);
      onClose(false);
      form.reset();
    }
  }, [data, toast]);

  useEffect(() => {
    console.log(isError);
    if (isError) {
      toast.error('Failed to add category. Please try again later.');
    }
  }, [data, toast]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg space-y-3 mb-4">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold">
            Add Course Category
          </DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <CategoriesForm />
            <DialogFooter className="mb-4 mx-2">
              <Button variant="outline" onClick={() => onClose(false)}>
                Cancel
              </Button>
              <Button type="submit" disabled={isLoading}>
                {isLoading ? 'Saving...' : 'Save Changes'}
              </Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};

export default DialogAddCategory;
